import React from 'react'
import { message, } from 'antd'
function Copy(props) {
    return (
        <a 
            style={{textDecoration:'underline', textDecorationStyle:'dotted',color:'black'}}    
            onClick={async () => {
            try {
                await navigator.clipboard.writeText(props.title);                                      
                // 可以添加一些UI状态反馈，例如显示"已复制"
                message.success('复制成功！')
            }   catch (err) {
                message.error('复制失败',);
            }                                  
        }}>{props.title}</a>
    )
}

export default Copy